// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Wave 1 — markdown polish for Ask (KaTeX math, highlight.js code blocks).
// Imported once globally so every <ReactMarkdown> consumer can use them.
import 'katex/dist/katex.min.css';
import 'highlight.js/styles/github.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexts/AuthContext'; // Import AuthProvider
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { createAppTheme } from './theme';

const theme = createAppTheme(false);

const rootElement = document.getElementById('root');
const appTree = (
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If react-snap pre-rendered this page, hydrate instead of full render
// This preserves the static HTML until React takes over
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, appTree);
} else {
  ReactDOM.createRoot(rootElement).render(appTree);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

